<template>
  <div>
    <div class="m-t-3">
      <h2 class="counterparties-user_block__title p-x-0">
        <span class="counterparties-user_block__title_text text-dark fz16 fw500">Attachments</span>
        <label class="counterparties-add_block_content__control_btn btn_add-file fz13" v-if="isEdit">
          <input type="file" multiple @change="addFiles">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.3333 11.3333H12.6667V6.66662C12.6667 6.2987 12.368 6 11.9999 6C11.632 6 11.3333 6.2987 11.3333 6.66662V11.3333H6.66662C6.2987 11.3333 6 11.632 6 11.9999C6 12.368 6.2987 12.6667 6.66662 12.6667H11.3333V17.3333C11.3333 17.7013 11.632 18 11.9999 18C12.368 18 12.6667 17.7013 12.6667 17.3333V12.6667H17.3333C17.7013 12.6667 18 12.368 18 11.9999C18 11.632 17.7013 11.3333 17.3333 11.3333Z" fill="#094172"/></svg>
          Attach files
        </label>
      </h2>
      <div class="counterparties-add_block_attachments">
        <div class="counterparties-add_block_attachment" v-for="(file, i) in files" :key="file.id">
          <counterparties-file-option-btn v-if="isEdit" :file="file" @edit-item="editFile(file, i)" @delete-item="deleteFile(file.id)"/>
<!--          <img v-on:click="openViewer(i)" :src="getUrlPreviewFile(file)" class="img-preview" alt="preview" v-if="getUrlPreviewFile(file) !== null && !getTypeVideo(file.name)">-->
          <img @click="openViewer(i)" class="counterparties-add_block_attachment-img" :src="file.thumbnail ? file.thumbnail : file.file" :alt="file.name" v-if="getAllowFile(file)">
          <img v-on:click="openViewer(i)" src="../../../assets/imgNone.svg" v-else>
<!--          <svg @click="openViewer(i)" class="counterparties-add_block_attachment-img" v-else width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.83985 48H41.1598C42.8167 48 44.1598 46.6569 44.1598 45V13.44L30.7198 0H6.83984C5.18299 0 3.83984 1.34315 3.83984 3V45C3.83984 46.6569 5.18299 48 6.83985 48Z" fill="#DEE3EA"/><path d="M44.1602 13.4414L33.7202 13.4414C32.0633 13.4414 30.7202 12.0983 30.7202 10.4414L30.7202 0.00140549L36.8002 6.18381L44.1602 13.4414Z" fill="#BDCBD6"/><path d="M12.0527 22.7051H15.0352C16.293 22.7051 17.2734 23.0742 17.9766 23.8125C18.6836 24.5508 19.0371 25.5859 19.0371 26.918C19.0371 28.2539 18.6855 29.2949 17.9824 30.041C17.2793 30.7871 16.2969 31.1602 15.0352 31.1602H12.0527V22.7051ZM13.3652 23.8359V30.0234H14.9121C15.8105 30.0234 16.498 29.7578 16.9746 29.2266C17.4551 28.6953 17.6953 27.9297 17.6953 26.9297C17.6953 25.9336 17.4551 25.1699 16.9746 24.6387C16.4941 24.1035 15.8066 23.8359 14.9121 23.8359H13.3652ZM23.9473 22.5645C25.1621 22.5645 26.125 22.957 26.8359 23.7422C27.5508 24.5273 27.9082 25.5918 27.9082 26.9355C27.9082 28.2793 27.5527 29.3438 26.8418 30.1289C26.1309 30.9102 25.166 31.3008 23.9473 31.3008C22.7285 31.3008 21.7637 30.9102 21.0527 30.1289C20.3418 29.3438 19.9863 28.2793 19.9863 26.9355C19.9863 25.5918 20.3418 24.5273 21.0527 23.7422C21.7637 22.957 22.7285 22.5645 23.9473 22.5645ZM23.9473 23.7188C23.1426 23.7188 22.5039 24.0078 22.0312 24.5859C21.5625 25.1641 21.3281 25.9473 21.3281 26.9355C21.3281 27.9199 21.5625 28.7012 22.0312 29.2793C22.5039 29.8574 23.1426 30.1465 23.9473 30.1465C24.748 30.1465 25.3828 29.8574 25.8516 29.2793C26.3242 28.7012 26.5605 27.9199 26.5605 26.9355C26.5605 25.9473 26.3242 25.1641 25.8516 24.5859C25.3828 24.0078 24.748 23.7188 23.9473 23.7188ZM32.7305 31.3008C31.543 31.3008 30.5996 30.9082 29.9004 30.123C29.2051 29.3379 28.8574 28.2734 28.8574 26.9297C28.8574 25.5938 29.207 24.5332 29.9062 23.748C30.6055 22.959 31.5469 22.5645 32.7305 22.5645C33.6914 22.5645 34.502 22.8359 35.1621 23.3789C35.8223 23.918 36.207 24.627 36.3164 25.5059H35.0156C34.8984 24.9629 34.6309 24.5293 34.2129 24.2051C33.7988 23.877 33.3047 23.7129 32.7305 23.7129C31.9609 23.7129 31.3457 24.0059 30.8848 24.5918C30.4277 25.1738 30.1992 25.9531 30.1992 26.9297C30.1992 27.918 30.4277 28.7031 30.8848 29.2852C31.3418 29.8633 31.959 30.1523 32.7363 30.1523C33.3223 30.1523 33.8145 30.0098 34.2129 29.7246C34.6152 29.4395 34.8828 29.041 35.0156 28.5293H36.3223C36.1621 29.4043 35.7656 30.0859 35.1328 30.5742C34.5039 31.0586 33.7031 31.3008 32.7305 31.3008Z" fill="#094172"/></svg>-->
          <p class="counterparties-add_block_attachment-text"
          tabindex="0"
          ref="fileText"
          @blur="blurEditable($event, file)"
          :class="{'editable': file.editable}"
          :contenteditable="file.editable"
          :title="file.name ? file.name : file.file">{{file.name ? file.name : file.file}}</p>
          <p v-if="file.file_type == 'FILE' && file.size" class="fz10 text-gray">{{file.size}}</p>
        </div>
      </div>
    </div>

    <file-viewer ref="fileViewer" :files="files" :isEdit="isEdit" @change-name="changeFileName" @delete-file="deleteFile" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import CounterpartiesFileOptionBtn from '@/components/counterparties/counterpartiesUser/counterpartiesFileOptionBtn.vue';
import fileViewer from '@/components/counterparties/counterpartiesUser/fileViewer'

export default {
  props: {
    files: Array,
    isEdit: {
      type: Boolean,
      default: true
    }
  },
  components: {
    CounterpartiesFileOptionBtn,
    fileViewer
  },
  data() {
    return {
      allowFormats: [".jpeg", ".png", ".raw", ".jpg", ".jfif", ".bmp", ".gif", "jp2", ".svg"],
      formatIMG: [".jpeg", ".png", ".raw", ".jpg", ".bmp", ".gif", ".svg"],
      formatVIDEO: [".mkv", ".mov"],
      formatIFRAME: [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".xps", ".ppt", ".pptx", ".ps", ".eps", '.txt'],
    }
  },
  methods: {
    ...mapActions(['axiosAddFileReturnData', 'axiosDeleteFileAnyway', 'axiosUpdateFile']),
    getTypeVideo(name) {
      let type = name.substring(name.lastIndexOf("."));
      if(this.formatVIDEO.indexOf(type) >=0) {
        return true
      }
      return false
    },
    getUrlPreviewFile(file) {
      if(file.thumbnail !== null && (''+file.thumbnail).length !== 0) {
        return this.getUrlForFile(file.thumbnail)
      } else {
        let type = file.name.substring(file.name.lastIndexOf("."));
        if(this.formatIMG.indexOf(type)>=0 || this.formatVIDEO.indexOf(type) >=0) {
          return this.getUrlForFile(file.file)
        }
      }
      return null
    },
    getUrlForFile(link) {
      if((''+link).indexOf(this.getURL()) >= 0) {
        return link;
      }
      if((''+link).indexOf('/media/') >= 0) {
        return this.getURL() + link;
      }
      if((''+link).indexOf('media/') >= 0) {
        return this.getURL() +"/" + link;
      }
      return this.getURL() +"/media/" + link;
    },
    getURL() {
      return process.env.VUE_APP_URL_SIMPLE
    },
    async addFiles(e) {
      let newFiles = e.target.files ? e.target.files : []

      let formData = new FormData();
      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i];
        formData.append("file", file);
        formData.append("name", file.name);

        let response = await this.axiosAddFileReturnData(formData)
        this.files.push(response)
        this.$emit('on-add-file')
      }
    },
    deleteFile(id) {
      let index = this.files.findIndex(file => {
        return file.id == id
      })
      this.files.splice(index, 1)
      this.axiosDeleteFileAnyway(id)
      this.$emit('on-del-file')
    },
    editFile(file, i) {
      this.$set(file, 'editable', true)

      this.$nextTick().then(()=>{
        this.$refs.fileText[i].focus()
      })
    },
    async blurEditable(e, file) {
      if(!file.editable) return
      file.editable = false
      file.name = e.target.innerText
      await this.axiosUpdateFile({id:file.id, name: e.target.innerText})
    },
    getAllowFile(file) {
      let fileType = file.file.substring(file.file.lastIndexOf("."))
      if(this.allowFormats.indexOf(fileType) >= 0){
        return true
      }
      return false
    },
    async changeFileName([id, name]) {
      let file = this.files.find(el => {
        return el.id == id
      })
      file.name = name
      await this.axiosUpdateFile({id, name})
    },
    openViewer(i) {
      this.$refs.fileViewer.showViewFileModal(i)
    }
  }
}
</script>

<style>

</style>